import { useMemo } from 'react';
import { FILTER_CONFIG } from '../utils/filterConfig';
import { parseServices } from '../utils/formatters';

/**
 * Хук для фільтрації пунктів забору
 * @param {Array} punkts - Масив всіх пунктів
 * @param {string} searchValue - Пошуковий запит
 * @param {Object} selectedFilters - Об'єкт вибраних фільтрів { filterId: true/false }
 * @returns {Object} { filteredPoints, filterCounts }
 */
const useCollectionPointsFilter = (punkts, searchValue, selectedFilters) => {

    const filteredPoints = useMemo(() => {
        let filtered = punkts;

        if (searchValue && searchValue.trim() !== '') {
            filtered = filtered.filter(point =>
                point.address.toLowerCase().includes(searchValue.toLowerCase())
            );
        }

        const activeFilters = Object.entries(selectedFilters)
            .filter(([_, isSelected]) => isSelected)
            .map(([filterId, _]) => filterId);

        if (activeFilters.length > 0) {
            filtered = filtered.filter(point => {
                const services = parseServices(point.opt);
                return activeFilters.every(filterId => {
                    const filter = FILTER_CONFIG.find(f => f.id === filterId);
                    return services.includes(filter.optKey);
                });
            });
        }

        return filtered;
    }, [punkts, searchValue, selectedFilters]);

    const filterCounts = useMemo(() => {
        const counts = {};

        FILTER_CONFIG.forEach(filter => {
            counts[filter.id] = punkts.filter(point => {
                const services = parseServices(point.opt);
                return services.includes(filter.optKey);
            }).length;
        });

        return counts;
    }, [punkts]);

    return {
        filteredPoints,
        filterCounts,
    };
};

export default useCollectionPointsFilter;
